"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Directory = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const directory_style_1 = __importDefault(require("./directory.style"));
const invisible_1 = __importDefault(require("../invisible/invisible"));
class Directory extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, columnTitle, columnTitle1, columnTitle2, columnTitle3, showColumnTitles, children } = this.props;
            return (jsx_runtime_1.jsxs("section", { children: [jsx_runtime_1.jsx(invisible_1.default, Object.assign({ visible: showColumnTitles }, { children: jsx_runtime_1.jsxs("section", Object.assign({ className: classes.root }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.columnTitle }, { children: columnTitle }), void 0),
                                jsx_runtime_1.jsx("div", Object.assign({ className: classes.columnTitle3 }, { children: columnTitle3 }), void 0),
                                jsx_runtime_1.jsx("div", Object.assign({ className: classes.columnTitle2 }, { children: columnTitle2 }), void 0),
                                jsx_runtime_1.jsx("div", Object.assign({ className: classes.columnTitle1 }, { children: columnTitle1 }), void 0)] }), void 0) }), void 0), children] }, void 0));
        };
    }
}
exports.Directory = Directory;
Directory.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    columnTitle: prop_types_1.default.node,
    columnTitle1: prop_types_1.default.node,
    columnTitle2: prop_types_1.default.node,
    columnTitle3: prop_types_1.default.node,
    showColumnTitles: prop_types_1.default.bool
};
Directory.defaultProps = {
    columnTitle: null,
    columnTitle1: null,
    columnTitle2: null,
    columnTitle3: null,
    showColumnTitles: false
};
exports.default = react_jss_1.default(directory_style_1.default)(Directory);
//# sourceMappingURL=directory.js.map